import { render, staticRenderFns } from "./UserDialog.vue?vue&type=template&id=2b1b39c4&scoped=true"
import script from "./UserDialog.vue?vue&type=script&lang=ts"
export * from "./UserDialog.vue?vue&type=script&lang=ts"
import style0 from "./UserDialog.vue?vue&type=style&index=0&id=2b1b39c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1b39c4",
  null
  
)

export default component.exports